import { render } from "./Jaygozinha.vue?vue&type=template&id=a0001c8e&scoped=true"
import script from "./Jaygozinha.vue?vue&type=script&lang=js"
export * from "./Jaygozinha.vue?vue&type=script&lang=js"

import "./Jaygozinha.vue?vue&type=style&index=0&id=a0001c8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0001c8e"]])

export default __exports__